<template>
  <section style="display: grid; grid-template-columns: 200px; padding: 10px; row-gap: 10px; height: 295px;">
    <div style="display: flex; justify-content: space-between; column-gap: 10px;">
      <b-button
        type="is-link"
        expanded
        @click="() => sort('asc')"
      >
        ↑ {{ $t('fdc.GRID_COMPONENT.BUTTON.ASCENDING') }}
      </b-button>
      <b-button
        type="is-link"
        expanded
        @click="() => sort('desc')"
      >
        ↓ {{ $t('fdc.GRID_COMPONENT.BUTTON.DESCENDING') }}
      </b-button>
    </div>

    <div style="display: flex; justify-content: flex-start; column-gap: 3px;">
      <b-button
        type="is-text"
        ref="setConditionFilterButton"
        @click="setConditionFilter"
        :active="isConditionFilter"
      >
        {{ $t('fdc.GRID_COMPONENT.BUTTON.FILTER_BY_COND') }}
      </b-button>
      <!-- | -->
      <b-button
        type="is-text"
        ref="setValueFilterButton"
        @click="setValueFilter"
        :active="!isConditionFilter"
        v-if="showValueFilter === true"
      >
        {{ $t('fdc.GRID_COMPONENT.BUTTON.FILTER_BY_VAL') }}
      </b-button>
      <!-- <a
        href="#"
        ref="setConditionFilterButton"
        @click="setConditionFilter"
      >
        Filter by Condition
      </a>
      &nbsp;|&nbsp;
      <a
        href="#"
        ref="setValueFilterButton"
        @click="setValueFilter"
      >
        Filter by Value
      </a> -->
    </div>

    <div
      v-if="isConditionFilter === true"
      ref="conditionFilter"
      style="display: grid; grid-template-columns: 200px; row-gap: 7px; height: 172px;"
    >
      <p style="margin-bottom: 0">
        {{ $t('fdc.GRID_COMPONENT.LABEL.SHOW_ITEMS_WHERE_THE_VALUE') }}
      </p>
      <b-select
        v-model="operator1"
        expanded
      >
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.CONTAINS') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.NOT_CONTAINS') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.EQUALS') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.NOT_EQUAL') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.BEGINS_WITH') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.ENDS_WITH') }}</option>
      </b-select>
      <b-input
        type="text"
        v-model="text1"
      />

      <div style="display: flex; justify-content: center;">
        <b-radio
          native-value="And"
          v-model="logicalOperator"
        >
          {{ $t('fdc.GRID_COMPONENT.LABEL.AND') }}
        </b-radio>
        <b-radio
          native-value="Or"
          v-model="logicalOperator"
        >
          {{ $t('fdc.GRID_COMPONENT.LABEL.OR') }}
        </b-radio>
      </div>

      <b-select
        v-model="operator2"
        expanded
      >
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.CONTAINS') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.NOT_CONTAINS') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.EQUALS') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.NOT_EQUAL') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.BEGINS_WITH') }}</option>
        <option>{{ $t('fdc.GRID_COMPONENT.LABEL.ENDS_WITH') }}</option>
      </b-select>
      <b-input
        type="text"
        v-model="text2"
      />
    </div>

    <div
      v-if="isConditionFilter === false && showValueFilter === true"
      ref="valueFilter"
      style="display: grid; grid-template-columns: 200px; row-gap: 7px; height: 172px;"
    >
      <b-input
        type="text"
        placeholder="Search"
        v-model="text3"
      />
      <b-checkbox
        v-model="checkedAll"
      >
        {{ $t('fdc.GRID_COMPONENT.LABEL.SELECT_ALL') }}
      </b-checkbox>
      <div style="display: flex; flex-direction: column; height: 100px; overflow-y: scroll; border: 1px solid #d3d7e1; padding: 5px; border-radius: 5px;">
        <b-field
          v-for="value in filteredValues"
          :key="value"
        >
          <b-checkbox
            :native-value="value"
            v-model="checkedValues"
          >
            {{ value }}
          </b-checkbox>
        </b-field>
      </div>
    </div>

    <div style="display: flex; justify-content: flex-end;">
      <b-button @click="setModel()">
        {{ $t('fdc.COMMON.BUTTON.RESET') }}
      </b-button>
    </div>
  </section>
</template>

<script>
const CONTAINS = 'Contains'
const NOT_CONTAINS = 'Not contains'
const EQUALS = 'Equals'
const NOT_EQUALS = 'Not equal'
const BEGINS_WITH = 'Begins with'
const ENDS_WITH = 'Ends with'

const AND = 'And'

function evaluate (text1, operator, text2) {
  // checkbox columns일 경우에 대한 처리 추가
  if (typeof text1 !== 'string') text1 = text1.toString()
  const value1 = text1.trim().toLowerCase()
  const value2 = text2.trim().toLowerCase()
  if (value1 === '') {
    return true
  }

  switch (operator) {
    case CONTAINS:
      return value1.indexOf(value2) !== -1

    case NOT_CONTAINS:
      return value1.indexOf(value2) === -1

    case EQUALS:
      return value1 === value2

    case NOT_EQUALS:
      return value1 !== value2

    case BEGINS_WITH:
      return value1.startsWith(value2)

    case ENDS_WITH:
      return value1.endsWith(value2)

    default:
      return false
  }
}

export default {
  name: 'StringFilter',

  data () {
    return {
      operator1: CONTAINS,
      operator2: CONTAINS,
      logicalOperator: AND,
      text1: '',
      text2: '',
      text3: '',
      allValues: [],
      checkedValues: [],
      isConditionFilter: true,
      showValueFilter: true
    }
  },

  computed: {
    checkedAll: {
      get: function () {
        return this.allValues.length === this.checkedValues.length
      },
      set: function (newValue) {
        if (newValue) {
          this.checkedValues = [...this.allValues]
        } else {
          this.checkedValues = []
        }
      }
    },
    filteredValues: function () {
      const text = this.text3.trim().toLowerCase()
      if (text === '') {
        return [...this.allValues]
      } else {
        return this.allValues.filter(value => value.toLowerCase().includes(text))
      }
    }
  },

  watch: {
    operator1: function () { this.params.filterChangedCallback() },
    operator2: function () { this.params.filterChangedCallback() },
    logicalOperator: function () { this.params.filterChangedCallback() },
    text1: function () { this.params.filterChangedCallback() },
    text2: function () { this.params.filterChangedCallback() },
    checkedValues: function () { this.params.filterChangedCallback() }
  },

  methods: {
    setConditionFilter () {
      this.isConditionFilter = true
      this.params.filterChangedCallback()
    },

    setValueFilter () {
      this.isConditionFilter = false
      this.params.filterChangedCallback()
    },

    init () {
      const set = new Set()
      const field = this.params.colDef.field
      this.params.api.forEachNode(node => set.add(node.data[field]))
      this.allValues = Array.from(set)
      this.checkedValues = Array.from(set)
      if (this.allValues.length > 100) this.showValueFilter = false // value filter의 항목이 100건 이상일 경우에는 value filter 비활성화
      else this.isConditionFilter = false
    },

    onNewRowsLoaded () {
      this.init()
    },

    afterGuiAttached () {
      this.init()
    },

    isFilterActive () {
      if (this.isConditionFilter) {
        return this.text1 !== '' || this.text2 !== ''
      } else {
        return this.allValues.length !== this.checkedValues.length
      }
    },

    getModel () {
      return {
        operator1: this.operator1,
        operator2: this.operator2,
        logicalOperator: this.logicalOperator,
        text1: this.text1,
        text2: this.text2,
        checkedValues: this.checkedValues
      }
    },

    setModel (model) {
      if (model === undefined || model === null) {
        this.operator1 = CONTAINS
        this.operator2 = CONTAINS
        this.logicalOperator = AND
        this.text1 = ''
        this.text2 = ''
        this.checkedValues = [...this.allValues]
      } else {
        this.operator1 = model.operator1
        this.operator2 = model.operator1
        this.logicalOperator = model.operator1
        this.text1 = model.operator1
        this.text2 = model.operator1
        this.checkedValues = model.checkedValues
      }
    },

    doesFilterPass (params) {
      const field = this.params.colDef.field
      const value = params.data[field]

      if (this.isConditionFilter) {
        const result1 = evaluate(value, this.operator1, this.text1)
        const result2 = evaluate(value, this.operator2, this.text2)

        if (this.text2 === '') {
          return result1
        } else {
          if (this.logicalOperator === AND) {
            return result1 && result2
          } else {
            return result1 || result2
          }
        }
      } else {
        return this.checkedValues.includes(value)
      }
    },

    sort (value) {
      const field = this.params.colDef.field
      this.params.columnApi.applyColumnState({
        state: [{
          colId: field,
          sort: value
        }]
      })
    }
  }
}
</script>
